import React from "react";
import PasswordForm from "../PasswordForm";

const CreatePassword = () => {
  return <PasswordForm formHeader="Set Password" isGotoLogin={false} />;
};

export default CreatePassword;
